import { render, staticRenderFns } from "./u-btn-custom.vue?vue&type=template&id=7fe26054&scoped=true&"
import script from "./u-btn-custom.vue?vue&type=script&lang=js&"
export * from "./u-btn-custom.vue?vue&type=script&lang=js&"
import style0 from "./u-btn-custom.vue?vue&type=style&index=0&id=7fe26054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe26054",
  null
  
)

export default component.exports